module.exports = __webpack_public_path__ + "components/page-header/static/snow-forecast__logo--white-8f641c079751f1b8fca6a0ae6f8d4440.svg";